/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

export const FAQ_TITLE = "سوالات متداول"
export const FAQ_SUB = "هر چیزی که درباره‌ی اپ، امکاناتش و مسیر گرفتن برنامه باید بدونی."

export const FAQ_GROUPS = [
  {
    title: "چرا سکویا فیتنس؟",
    items: [
      {
        q: "چرا می‌گن سکویا فیتنس کامل‌ترین اپلیکیشن ورزشی ایرانه؟",
        a: (
          <>
        <p>چون هر چیزی که توی مسیر ورزش لازم داری، همین‌جا کنار هم هست. مربی واقعی برنامه‌ی تمرین و تغذیه‌ت رو مخصوص خودت می‌نویسه، تو هم همون‌جا با ویدیوی آموزشی، تایمر و ثبت ست تمرین می‌کنی. پیشرفتت، RPE، BMI و تقویم تمرین هم همین‌جاست. برای حرف زدن با مربی هم لازم نیست سراغ پیام‌رسان دیگه‌ای بری، چون چت مربی توی خود اپلیکیشنه. بخش‌ها به هم وصلن: ستی که ثبت می‌کنی خودش به مربی می‌رسه و مربی با اعداد واقعی خودت برنامه رو عوض می‌کنه.</p>
          </>
        ),
      },
      {
        q: "بدون مربی هم می‌شه از سکویا فیتنس استفاده کرد؟",
        a: (
          <>
        <p>آره. با پلن پایه، یعنی Sequoia Pro، ابزارها، ویدیوهای آموزشی و برنامه‌ساز دستته، فقط مربی اختصاصی نداری.</p>
          </>
        ),
      },
      {
        q: "سکویا فیتنس نسخه‌ی رایگان داره؟",
        a: (
          <>
        <p>آره. ثبت‌نام رایگانه و باهاش به ابزارها و یه بخشی از ویدیوهای آموزشی می‌رسی. برای بقیه‌ی امکانات باید اشتراک فعال کنی.</p>
          </>
        ),
      },
    ],
  },
  {
    title: "امکانات",
    items: [
      {
        q: "امکانات پلتفرم سکویا فیتنس چیه؟",
        a: (
          <>
        <ul>
          <li>برنامه‌ی تمرین و تغذیه‌ای که مربی مخصوص خودت می‌نویسه</li>
          <li>پلیر تمرین: ویدیو، تایمر استراحت و ثبت وزنه و تکرار</li>
          <li>تقویم جلسه‌های تمرین</li>
          <li>پیگیری پیشرفت: رکوردها، حجم تمرین، وزن، اندازه‌ها و عکس‌ها</li>
          <li>کتابخونه‌ی تمرین‌ها، هر کدوم با ویدیوی آموزشی</li>
          <li>ابزارها: محاسبه‌گر 1RM و پیشنهاد وزنه و BMI، تایمر تمرین، برنامه‌ساز، خودارزیابی اصلاحی، یادآور آب و یادآور دوره‌ی قاعدگی</li>
          <li>سکویا چت برای حرف زدن با مربی و پشتیبانی</li>
        </ul>
          </>
        ),
      },
      {
        q: "چرا پلتفرم سکویا فیتنس هوشمنده؟",
        a: (
          <>
        <p>چون هر بخش می‌دونه بقیه چی‌کار می‌کنن:</p>
        <ul>
          <li>برنامه‌ی مربی خودش روی تقویمت میاد. یه روز نرسیدی تمرین کنی؟ جلسه رو جابه‌جا می‌کنی و بقیه‌ی برنامه سر جاش می‌مونه.</li>
          <li>با هر ستی که ثبت می‌کنی، رکوردها و حجم تمرینت ساخته می‌شه و مربی هم خبردار می‌شه.</li>
          <li>ابزارها به تمرین وصلن: RPE می‌گه هر ست رو با چه وزنه‌ای بزنی، و خودارزیابی اصلاحی بعد از تست‌ها تمرین اصلاحی پیشنهاد می‌ده.</li>
          <li>یادآورها با اطلاعات خودت تنظیم می‌شن: هدف آب روزانه از وزنت درمیاد و پیش‌بینی چرخه‌ی قاعدگی از تاریخ‌هایی که خودت وارد کردی.</li>
          <li>دستیار داخل پلتفرم می‌دونه کجایی و چه پلنی داری، برای همین جواب‌هاش به کار خودت می‌خوره.</li>
        </ul>
          </>
        ),
      },
      {
        q: "برنامه‌ی تمرین، پیگیری پیشرفت و مربی توی سکویا فیتنس چطور به هم وصلن؟",
        a: (
          <>
        <p>برنامه‌ی مربی رو توی پلیر اجرا می‌کنی. نتیجه‌ی ست‌هات خودکار می‌ره سمت پیگیری پیشرفت و مربی، و مربی با همون داده‌ها برنامه رو به‌روز می‌کنه.</p>
          </>
        ),
      },
      {
        q: "محاسبه‌گر 1RM و پیشنهاد وزنه، BMI و تایمر تمرین چه کاری می‌کنن؟",
        a: (
          <>
        <ul>
          <li>
            <b>محاسبه‌گر 1RM و پیشنهاد وزنه:</b>
             بهت می‌گه هر ست رو با چه شدتی بزنی.
          </li>
          <li>
            <b>محاسبه‌گر BMI:</b>
             شاخص توده‌ی بدنی، وزن هدف و کالری روزانه‌ت رو حساب می‌کنه.
          </li>
          <li>
            <b>خودارزیابی اصلاحی:</b>
             با چند تست ساده ضعف‌ها و ناهماهنگی‌های بدنت رو پیدا می‌کنه و تمرین اصلاحی پیشنهاد می‌ده.
          </li>
          <li>
            <b>تایمر تمرین:</b>
             استراحت بین ست، تاباتا، EMOM و اینتروال.
          </li>
          <li>
            <b>برنامه‌ساز:</b>
             برنامه‌ی تمرینی خودت رو خودت می‌چینی.
          </li>
        </ul>
          </>
        ),
      },
      {
        q: "یادآور نوشیدن آب چطور کار می‌کنه؟",
        a: (
          <>
        <p>هدف روزانه‌ی آب رو از روی وزن بدنت حساب می‌کنه. هر وقت آب خوردی، با دکمه‌ی لیوان یا بطری سریع ثبتش می‌کنی. توی بازه‌هایی هم که خودت تعیین کردی، اعلان یادآوری برات میاد.</p>
          </>
        ),
      },
      {
        q: "یادآور دوره‌ی قاعدگی و پیش‌بینی پریود چطور کار می‌کنه؟",
        a: (
          <>
        <p>تاریخ پریودهای قبلی‌ت رو وارد می‌کنی و با میانگین چرخه‌هات، چرخه‌ی بعدی پیش‌بینی می‌شه. روز چرخه و فاز فعلی رو نشونت می‌ده، چند روز مونده به موعد اعلان می‌فرسته و روی تقویم هم دیده می‌شه. علائم و حال روزانه‌ت رو هم می‌تونی ثبت کنی، و اگه علامت خطرناکی بنویسی، می‌گه به پزشک مراجعه کنی. بارداری، قرص هورمونی و PCOS هم پوشش داده شدن.</p>
          </>
        ),
      },
    ],
  },
  {
    title: "شروع کار",
    items: [
      {
        q: "چطور از مربی آنلاین برنامه‌ی تمرینی اختصاصی بگیرم؟",
        a: (
          <>
        <ol>
          <li>پلن مورد نظرت رو از صفحه‌ی سفارش انتخاب می‌کنی.</li>
          <li>مربی‌ت رو از بین مربی‌های همون پلن برمی‌داری، رشته‌ی ورزشی (و برای پلن‌هایی که برنامه‌ی غذایی دارن، نوع رژیم) رو مشخص می‌کنی و مدت اشتراک رو انتخاب می‌کنی.</li>
          <li>توی سبد خرید کد تخفیفت رو (اگه داری) وارد می‌کنی و پرداخت رو انجام می‌دی.</li>
          <li>بعد از تأیید پرداخت، فرم سنجش رو پر می‌کنی: هدف، سابقه، محدودیت‌ها، اندازه‌ها و عکس.</li>
          <li>مربی برنامه رو مخصوص خودت می‌نویسه و داخل اپ بهت تحویل می‌ده.</li>
        </ol>
          </>
        ),
      },
      {
        q: "بعد از ثبت سفارش چه مراحلی داره؟",
        a: (
          <>
        <p>پیشرفت سفارشت رو توی «سفارش‌های من» قدم‌به‌قدم می‌بینی:</p>
        <ol>
          <li>ثبت سفارش</li>
          <li>تأیید پرداخت (فقط برای کارت‌به‌کارت، چون پرداخت درگاه بانکی همون لحظه تأیید می‌شه)</li>
          <li>تکمیل اطلاعات (فرم سنجش)</li>
          <li>تست اصلاحی، اگه پلنت نیاز داشته باشه</li>
          <li>آماده‌سازی برنامه</li>
          <li>اختصاص برنامه</li>
          <li>تکمیل شده</li>
        </ol>
          </>
        ),
      },
      {
        q: "کدوم پلن تمرین و تغذیه به درد من می‌خوره؟",
        a: (
          <>
        <div className="seq-faq-plans">
          <div className="seq-faq-plan">
            <span className="seq-faq-plan-ic">
              <img src="a/faq-plan-training.webp" alt="" width="144" height="144" loading="lazy" decoding="async" />
            </span>
            <span className="seq-faq-plan-txt">
              <b dir="ltr">Training</b>
              <span>برنامه‌ی تمرینی شخصی‌سازی‌شده و چت مستقیم با مربی</span>
            </span>
          </div>
          <div className="seq-faq-plan">
            <span className="seq-faq-plan-ic">
              <img src="a/faq-plan-nutrition.webp" alt="" width="144" height="144" loading="lazy" decoding="async" />
            </span>
            <span className="seq-faq-plan-txt">
              <b dir="ltr">Nutrition</b>
              <span>برنامه‌ی غذایی شخصی‌سازی‌شده و چت مستقیم با مربی</span>
            </span>
          </div>
          <div className="seq-faq-plan">
            <span className="seq-faq-plan-ic">
              <img src="a/faq-plan-complete.webp" alt="" width="144" height="144" loading="lazy" decoding="async" />
            </span>
            <span className="seq-faq-plan-txt">
              <b dir="ltr">Complete</b>
              <span>هم برنامه‌ی تمرینی، هم غذایی، با پیگیری پیشرفت هر ۲۱ روز</span>
            </span>
          </div>
          <div className="seq-faq-plan">
            <span className="seq-faq-plan-ic">
              <img src="a/faq-plan-fix.webp" alt="" width="144" height="144" loading="lazy" decoding="async" />
            </span>
            <span className="seq-faq-plan-txt">
              <b dir="ltr">Fix</b>
              <span>تست و ارزیابی، برنامه‌ی اصلاحی-تمرینی و تمرینی؛ برنامه‌ی غذایی هم به‌صورت افزودنی</span>
            </span>
          </div>
          <div className="seq-faq-plan seq-faq-plan-wide">
            <span className="seq-faq-plan-ic is-duo">
              <img src="a/faq-plan-elite.webp" alt="" width="144" height="144" loading="lazy" decoding="async" />
              <img src="a/faq-plan-apex.webp" alt="" width="144" height="144" loading="lazy" decoding="async" />
            </span>
            <span className="seq-faq-plan-txt">
              <b dir="ltr">Elite و Apex</b>
              <span>بازخورد اولویت‌دار، آنالیز ماهانه‌ی Body Composition و برنامه‌ریزی سه‌ماهه. Elite مشاوره‌ی ماهانه داره و Apex مشاوره‌ی هفتگی و یه جلسه‌ی تمرین زیر نظر مربی در هر ماه</span>
            </span>
          </div>
          <div className="seq-faq-plan seq-faq-plan-wide">
            <span className="seq-faq-plan-ic">
              <img src="a/faq-plan-pro.webp" alt="" width="144" height="144" loading="lazy" decoding="async" />
            </span>
            <span className="seq-faq-plan-txt">
              <b dir="ltr">Sequoia Pro</b>
              <span>آرشیو تمرین‌ها، برنامه‌ساز، ابزارها و پیگیری پیشرفت؛ بدون برنامه‌ی اختصاصی مربی</span>
            </span>
          </div>
        </div>
          </>
        ),
      },
      {
        q: "برنامه‌ی تمرینی من چند روزه آماده می‌شه؟",
        a: (
          <>
        <p>بین ۲۴ ساعت تا دو هفته. چون مربی برنامه رو مخصوص خودت می‌نویسه و به ترافیک سفارش‌ها بستگی داره، زمان می‌بره. هر لحظه می‌تونی مرحله‌ی سفارشت رو توی «سفارش‌های من» ببینی.</p>
          </>
        ),
      },
      {
        q: "کلاس آنلاین و حضوری رو چطور رزرو کنم؟",
        a: (
          <>
        <p>کلاس‌های خصوصی و نیمه‌خصوصی توی همین صفحه‌ی سفارش هستن. ظرفیت کلاس حضوری فعلاً تکمیل شده؛ می‌تونی توی لیست انتظار ثبت‌نام کنی و مربی ظرف حداکثر یک هفته برای هماهنگی باهات تماس می‌گیره. رزرو کلاس آنلاین خصوصی هم از همین صفحه انجام می‌شه.</p>
          </>
        ),
      },
      {
        q: "اپلیکیشن سکویا فیتنس رو چطور نصب کنم؟",
        a: (
          <>
        <p>نسخه‌ی اندروید رو از همین صفحه دانلود می‌کنی. نسخه‌ی وب هم از app.sequoia.fitness نصب می‌شه.</p>
          </>
        ),
      },
    ],
  },
  {
    title: "پرداخت و اطمینان",
    items: [
      {
        q: "روش‌های پرداخت سکویا فیتنس چیه؟",
        a: (
          <>
        <p>سکویا فیتنس نماد اعتماد الکترونیکی (اینماد) داره و پرداخت‌ها از طریق درگاه پرداخت آنلاین امن انجام می‌شه. کاربرانی که خارج از ایران هستن می‌تونن از کارت‌به‌کارت یا روش‌های دیگه استفاده کنن؛ برای هماهنگی، از «سکویا چت» با پشتیبانی در تماس باشن.</p>
          </>
        ),
      },
      {
        q: "می‌تونم سفارشم رو لغو کنم؟",
        a: (
          <>
        <p>تا قبل از پرداخت آره، خودت از «سفارش‌های من» لغوش می‌کنی. بعد از پرداخت فقط تا قبل از شروع نوشتن برنامه می‌شه بررسی کرد و باید از «سکویا چت» هماهنگ کنی. وقتی برنامه تحویل داده شد، پولش برنمی‌گرده.</p>
          </>
        ),
      },
    ],
  },
]
